import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanLoad, Route, RouterStateSnapshot, UrlSegment, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';

import {ApiService, LanguagesService} from '@app/services';

@Injectable({
  providedIn: 'root'
})
export class LanguageGuard implements CanActivate, CanLoad {
    
    constructor (
        private router: Router,
        private apiService : ApiService,
        private languagesService : LanguagesService
    ) {}
    
    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {             
            return this.initLanguages();
    }
    
    canLoad(
        route: Route,
        segments: UrlSegment[]): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {  
            return this.initLanguages();
    }
    
    async initLanguages(){
        this.languagesService.init(this.apiService);
        return true;
    }
}
